module.exports = __webpack_public_path__ + "img/Schlafwagen.1fda8775.svg";